<template>
  <q-card flat class="upload-tab">
    <q-card-section class="bg-white fit cards-grid">
      <DoiCard type="member" />
      <DoiCard type="publisher" />
      <!-- TODO: remove or show it -->
      <!--      <UploadCard title="Dimensions DOIs">-->
      <!--        <InputFetch />-->
      <!--      </UploadCard>-->
    </q-card-section>
  </q-card>
</template>

<script>
// Components
import DoiCard from './components/DoiCard'
// import UploadCard from './components/UploadCard'
// import InputFetch from './components/InputFetch'

export default {
  components: {
    DoiCard
    // UploadCard,
    // InputFetch
  }
}
</script>

<style lang="stylus" scoped>
.upload-tab {
  padding 20px
  background #E6E6E6

  >>> .gap-sm {
    display grid
    grid-auto-flow column
    gap 10px
  }

  .cards-grid {
    display grid
    grid-template-columns repeat(auto-fit, minmax(min-content, 500px))
    gap 10px
    justify-content space-evenly
    align-items start
  }
}
</style>
